const parametersGateway = {
    fetchParameters: async (token: string) => {
      // const url = `/check_token/${token}`;
      try {
        // const res = await axiosClient.get(url);
        const res = [
          { id: 1, displayName: 'Torque', key: 'ns=2;s=motor/torque'},
          { id: 2,displayName: 'Temperature', key: 'ns=2;s=motor/Temperature' },
        ];
        return {
          status: 'success',
          res,
        };
      } catch (error) {
        return {
          status: 'error',
          error,
        };
      }
    }
}

export default parametersGateway;